import React, { useEffect } from "react";
import { useLocation, useNavigate, NavLink, Link } from "react-router-dom";
import adminAction from "../../redux/admin/action";
import employeeAction from "../../redux/employee/action";
import supportAction from "../../redux/support/action";
import logo from "../../assets/images/logo.png";
import miniLogo from "../../assets/images/logoIcon.png";
import { useDispatch } from "react-redux";

function Sidebar({ authType, setAuthType, supportPermissions }) {
  const location = useLocation();
  const navigate  = useNavigate();
  const dispatch  = useDispatch();
  const { setAdmin }         = adminAction;
  const { setEmployee }      = employeeAction;
  const { setSupportMember } = supportAction;

  // null → admin (show all); array → support (show only permitted keys)
  const can = (key) => supportPermissions === null || (supportPermissions || []).includes(key);

  const logout = () => {
    dispatch(setAdmin({}));
    dispatch(setEmployee({}));
    dispatch(setSupportMember({}));
    setAuthType("");
    localStorage.removeItem("admintoken");
    localStorage.removeItem("emptoken");
    localStorage.removeItem("supporttoken");
    navigate("/");
  };

  useEffect(() => { window.scrollTo(0, 0); }, [location]);

  const NavItem = ({ to, icon, label, end }) => (
    <li className="nav-item my-2">
      <NavLink className="nav-link sidebar-Link fw-500" to={to} end={end}>
        <i className={`fa-solid ${icon}`} />
        <span>{label}</span>
      </NavLink>
    </li>
  );

  return (
    <>
      <ul className="navbar-nav shadow sidebar sidebar-dark accordion zi-1 pb-100" id="accordionSidebar">

        {/* Brand */}
        <Link className="sidebar-brand d-flex align-items-center justify-content-center mt-2" to="/">
          <div className="sidebar-brand-text mx-3">
            <img src={logo} className="w-100" alt="Shabbir Transport" />
          </div>
          <div className="mini">
            <img src={miniLogo} className="w-100" alt="Shabbir Transport" />
          </div>
        </Link>

        {(authType === "admin" || authType === "support") && (
          <>
            {can("dashboard")     && <NavItem to="/admin/dashboard"      icon="fa-house"                 label="Dashboard"           end />}
            {can("vehicles")      && <NavItem to="/admin/vehicles"        icon="fa-users"                 label="Vehicles" />}
            {can("fuel")          && <NavItem to="/admin/fuel"            icon="fa-gas-pump"              label="Fuel" />}
            {can("drivers")       && <NavItem to="/admin/drivers"         icon="fa-car"                   label="Driver/Employee" />}
            {can("routes")        && <NavItem to="/admin/routes"          icon="fa-road"                  label="Route" />}
            {can("students")      && <NavItem to="/admin/students"        icon="fa-graduation-cap"        label="Students" />}
            {can("fees")          && <NavItem to="/admin/fees"            icon="fa-file-invoice-dollar"   label="Fees" />}
            {can("feeReceipts")   && <NavItem to="/admin/fee-receipts"    icon="fa-receipt"               label="Fee Receipts" />}
            {can("salary")        && <NavItem to="/admin/salary"          icon="fa-money-bill"            label="Salary" />}
            {can("loans")         && <NavItem to="/admin/loans"           icon="fa-money-bill"            label="Loans" />}
            {can("paymentMethod") && <NavItem to="/admin/payment-method"  icon="fa-money-bill"            label="Payment Method" />}
            {can("maintenance")   && <NavItem to="/admin/maintenance"     icon="fa-screwdriver-wrench"    label="Maintenance" />}
            {can("enquiries")     && <NavItem to="/admin/enquiries"       icon="fa-inbox"                 label="Contact/Enquiries" />}
            {can("bookings")      && <NavItem to="/admin/bookings"        icon="fa-calendar-check"        label="Bookings" />}
            {can("entry")         && <NavItem to="/admin/entry"           icon="fa-clipboard-list"        label="Entry" />}
            {can("bill")          && <NavItem to="/admin/bill"            icon="fa-file-invoice"          label="Bill" />}

            {/* Support Members — admin only, never shown to support */}
            {authType === "admin" && (
              <NavItem to="/admin/support-members" icon="fa-user-shield" label="Support Members" />
            )}
          </>
        )}

        <li className="nav-item my-2">
          <div className="nav-link sidebar-Link fw-500" onClick={logout}>
            <i className="fa-solid fa-arrow-right-from-bracket" />
            <span>Logout</span>
          </div>
        </li>
      </ul>
    </>
  );
}

export default Sidebar;
